import { transformExtent } from 'ol/proj';
import { checkPermissions } from '../utils/permissionUtils';
let extendContextMenuItems = [];
const validateEmail = (email) => {

    let result = false;

    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        result = true;
    }


    return result;
}
var groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

const sleep = (milliseconds) => new Promise(resolve => setTimeout(resolve, milliseconds));

const createAuthorizedWmsSource = (mapTool, options) => {
    const source = mapTool.createTileLayerSourceWithHeadersLy(options);

    source.setTileLoadFunction((tile, src) => {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';

        const markAsError = () => {
            // OpenLayers TileState.ERROR
            if (typeof tile.setState === 'function') tile.setState(3);
        };

        xhr.addEventListener('load', () => {
            if (xhr.status < 200 || xhr.status >= 300 || !xhr.response) {
                markAsError();
                return;
            }

            const objectUrl = URL.createObjectURL(xhr.response);
            const image = tile.getImage();
            image.addEventListener('load', () => URL.revokeObjectURL(objectUrl), { once: true });
            image.src = objectUrl;
        });
        xhr.addEventListener('error', markAsError);
        xhr.addEventListener('abort', markAsError);

        xhr.open('GET', src);
        const tokenKey = window.mapTokenKey || window.layerControlTokenKey || process.env.REACT_APP_LS_TOKEN;
        const token = tokenKey ? localStorage.getItem(tokenKey) : null;
        if (token) xhr.setRequestHeader('ozt', token);
        xhr.send();
    });

    return source;
};

const toPascalCase = (string) =>
    `${string}`
        .replace(/[-_]+/g, ' ')
        .replace(/[^\w\s]/g, '')
        .replace(/\s+(.)(\w+)/g, (_, first, rest) => first.toUpperCase() + rest.toLowerCase())
        .replace(/\s/g, '')
        .replace(/\w/, (s) => s.toUpperCase());


const maxWindow = () => {
    const elem = document.body;
    if ((document.fullScreenElement !== undefined && document.fullScreenElement === null) || (document.msFullscreenElement !== undefined && document.msFullscreenElement === null) || (document.mozFullScreen !== undefined && !document.mozFullScreen) || (document.webkitIsFullScreen !== undefined && !document.webkitIsFullScreen)) {
        if (elem.requestFullScreen) {
            elem.requestFullScreen();
        } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullScreen) {
            elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
        }
    } else {
        if (document.cancelFullScreen) {
            document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    }
}

const copyGeometry = (mapTool, toast) => {
    var interaction = mapTool.getInteraction("selectTranslate");

    if (interaction && interaction.getFeatures().getArray().length > 0) {


        let newFeature = interaction.getFeatures().getArray()[0].clone();

        mapTool.findLayer('workspace-layer').getSource().addFeature(newFeature);;

        toast.current.show({ severity: 'success', summary: 'Bilgi', detail: 'Obje kopyalandı.' });
    }
    else {
        toast.current.show({ severity: 'info', summary: 'Bilgi', detail: 'Geometri seçilmedi.' });
        toast.current.show({ severity: 'info', summary: 'Bilgi', detail: 'Seç / Çizim Taşı Butonundan Çizim Seçiniz.' });
        return;

    }
}

const defaultZoom = (map, maxZoom) => {

    map.getView().on('change:resolution', function () {
        var zoom = map.getView().getZoom();
        if (zoom > maxZoom) {
            map.getView().setZoom(maxZoom);
        }
    });
}

const positionContextMenuResponsive = (menuElement, clientX, clientY) => {
    const menuWidth = menuElement.offsetWidth;
    const menuHeight = menuElement.offsetHeight;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    let x, y;

    if (windowWidth <= 768) {

        x = (windowWidth - menuWidth) / 2;
        y = (windowHeight - menuHeight) / 2;
    } else {

        x = clientX;
        y = clientY;

        if ((x + menuWidth) > windowWidth) x = windowWidth - menuWidth - 10;
        if ((y + menuHeight) > windowHeight) y = windowHeight - menuHeight - 10;
    }

    menuElement.style.left = `${x}px`;
    menuElement.style.top = `${y}px`;
    menuElement.style.zIndex = 9999999999 + " !important";
}


const addContextMenu = (contextMenu, items, map) => {
    for (var i = 0; i < contextMenu.items; i++) {

        removeContextMenuItem(contextMenu, contextMenu.items[i].text);
    }
    for (var i = 0; i < items; i++) {

        removeContextMenuItem(contextMenu, items[i].text);
    }
    for (var i = 0; i < contextMenu.getDefaultItems().length; i++) {

        removeContextMenuItem(contextMenu, contextMenu.getDefaultItems()[i].text);
    }
    extendContextMenuItems = [...new Set([...contextMenu.getDefaultItems(), ...contextMenu.items, ...extendContextMenuItems])];
    for (var i = 0; i < items.length; i++) {
        if (extendContextMenuItems.find(x => x == items[i] != null)) {
            if (!items[i]["permission_name"] || (items[i]["permission_name"] && checkPermissions([items[i]["permission_name"]]))) {

                extendContextMenuItems.push(items[i]);
            }
        }
    }
    contextMenu.clear();
    contextMenu.extend(extendContextMenuItems);
    if (!map)
        return;

    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    var fnc = function (event) {
        event.preventDefault(); // Varsayılan menüyü kapat
        var a = document.querySelector(".ol-ctx-menu-container");
        const menu = contextMenu.element;
        if (event.originalEvent.clientX <= 1) {
            a.style.display = 'none';
            return;
        }
        a.style.display = 'block';
        setTimeout(() => {
            var height = a.offsetHeight;



            let posX = event.originalEvent.clientX;
            let posY = event.originalEvent.clientY;

            a.style.left = `${event.originalEvent.clientX}px`;

            if (posY <= height) {

                a.style.top = `${(event.originalEvent.clientY)}px`;

            }
            else {
                a.style.top = `${(event.originalEvent.clientY - height)}px`;


            }



        }, 10);

    }
    map.un('contextmenu', fnc)
    map.on('contextmenu', fnc);

    let touchTimeout = null;

    map.getViewport().addEventListener('touchstart', function (e) {
        touchTimeout = setTimeout(() => {
            const touch = e.touches[0];

            if (!contextMenu) {
                console.warn("Context menu elementi DOM'da bulunamadı!");
                return;
            }

            positionContextMenuResponsive(contextMenu.element, touch.clientX, touch.clientY);
            contextMenu.element.style.display = 'block';
            contextMenu.element.style.zIndex = 55555;;
        }, 600);
    });

    map.getViewport().addEventListener('touchend', function () {
        clearTimeout(touchTimeout);
    });

}


const removeContextMenuItem = (contextMenu, itemText, map) => {

    var itemIndex = extendContextMenuItems.findIndex(item => item.text === itemText);
    if (itemIndex !== -1) {

        extendContextMenuItems.splice(itemIndex, 1); // Diziden kaldırın
    }
    contextMenu.clear();
    contextMenu.extend(extendContextMenuItems);

    if (!map)
        return;
    var fnc = function (event) {
        event.preventDefault(); // Varsayılan menüyü kapat
        //const menu = contextMenu.element;
        //var a = document.querySelector(".ol-ctx-menu-container");
        //a.style.display = 'block';
        //setTimeout(() => {
        //    var height = (extendContextMenuItems.length * 25);

        //    a.style.left = `${event.originalEvent.clientX}px`;
        //    a.style.top = `${event.originalEvent.clientY + 80}px`;

        //    if ((event.originalEvent.clientY + height) >= map.getSize()[1]) {
        //        a.style.left = `${event.originalEvent.clientX}px`;
        //        a.style.top = `${((event.originalEvent.clientY - height))}px`;
        //    }

        //    else if ((event.originalEvent.clientY - height) <= 0) {
        //        a.style.left = `${event.originalEvent.clientX}px`;

        //        a.style.top = `${(event.originalEvent.clientY)}px`;

        //    }


        //}, 5);
    }
    map.un('contextmenu', fnc)
    map.on('contextmenu', fnc);


}



const getCardColor = (kind) => {
    switch (kind) {
        case "book":
            return "green";
        case "game":
            return "red";
        case "movie":
            return "blue";
        default:
            break;
    }
}

const getOverlayByName = (name, mapTool) => {
    var overlays = mapTool.getMap().getOverlays().getArray();

    var selectedOverlay = overlays.find(function (overlay) {
        return overlay.options.id === name;
    });

    return selectedOverlay;

};
//Featureye verilen özelliğe göre propertieslerini popupda göstermek için eklenmiştir
const addPopup = (mapTool, popup_info_key, layerName, popupId) => {
    let overlay = getOverlayByName(popupId, mapTool);
    if (!overlay) {
        overlay = mapTool.addOverlayCustom(popupId, popupId);
    }

    overlay.setPosition(undefined);

    // Aynı event'in birden çok kez eklenmesini önleyelim
    if (!mapTool.__customerInfoClickBound) {
        mapTool.__customerInfoClickBound = true;

        mapTool.getMap().on('singleclick', (evt) => {
            overlay.setPosition(undefined);

            const feature = mapTool.getMap().forEachFeatureAtPixel(evt.pixel, function (feature) {
                if (feature.get("layerName") === layerName) return feature;
            });

            if (!feature || !feature.get(popup_info_key)) return;

            const coordinate = evt.coordinate;
            const container = document.getElementById(popupId);
            const content = document.getElementById(popupId + '-content');
            const closer = document.getElementById(popupId + '-popup-closer');

            const object = feature.get(popup_info_key);

            // wkt / geoloc içerenleri ele
            const columns = Object.entries(object)
                .filter(([k]) => k.indexOf("wkt") <= -1 && k.indexOf("geoloc") <= -1)
                .map(([k, v]) => ({ name: k, value: v }));

            // Basit HTML escape (XSS'e karşı)
            const esc = (v) => {
                if (v === null || v === undefined) return '';
                return String(v)
                    .replace(/&/g, "&amp;")
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;")
                    .replace(/"/g, "&quot;")
                    .replace(/'/g, "&#39;");
            };

            let html = '';
            html += '<table class="info-table" border="1" style="border-collapse: collapse; width: 400px;">';
            html += '<tbody>';

            for (const element of columns) {
                const key = element.name;
                const label = element.displayName ?? key; // <-- kritik düzeltme
                const value = element.value;              // <-- doğrudan element.value kullan
                html += `<tr><td>${esc(label)}</td><td>${esc(value)}</td></tr>`;
            }

            html += '</tbody></table>'; // tabloları kapatalım

            content.innerHTML = html;
            overlay.setPosition(coordinate);
        });
    }
};


const markEmptyFieldsWithAsterisk = (containerId, isBorder = false) => {

    const container = document.getElementById(containerId);
    if (!container) return true;

    let allValid = true;

    const elements = container.querySelectorAll(
        '.required.p-inputtext, .required.p-dropdown, .required.p-multiselect, .required.p-inputnumber, .required.p-calendar'
    );

    elements.forEach(el => {
        let isEmpty = false;


        let inputToStyle = el;
        if (el.classList.contains('p-inputtext')) {
            isEmpty = !(el.value?.trim());
        }


        else if (el.classList.contains('p-dropdown')) {
            const selectedValue = el.getAttribute('aria-label') || '';
            const hasPlaceholderClass = el.classList.contains('p-placeholder');
            const isEmptyClass = el.querySelector('.p-dropdown-label-empty');
            isEmpty = !selectedValue.trim() || hasPlaceholderClass || isEmptyClass;
            const innerText = el.innerText.trim().toLowerCase().indexOf("select") >= 0 || el.innerText.trim().toLowerCase().indexOf("seçiniz") >= 0
            isEmpty = innerText;
        }


        else if (el.classList.contains('p-multiselect')) {
            const label = el.querySelector('.p-multiselect-label');
            const labelText = label?.textContent?.trim() || '';
            const isEmptyClass = el.querySelector('.p-multiselect-label-empty');
            isEmpty = !labelText || isEmptyClass;
            const innerText = el.innerText.trim().toLowerCase().indexOf("select") >= 0 || el.innerText.trim().toLowerCase().indexOf("seçiniz") >= 0
            isEmpty = innerText;
        }


        else if (el.classList.contains('p-inputnumber')) {
            const inputEl = el.querySelector('input.p-inputnumber-input');
            isEmpty = !(inputEl?.value?.trim());
        }

        else if (el.classList.contains('p-calendar')) {
            const inputEl = el.querySelector('input.p-inputtext');
            isEmpty = !(inputEl?.value?.trim());
        }


        const wrapper = el.parentElement;

        const parent = wrapper?.parentElement;
        const hasAsterisk = parent?.querySelector('.required-asterisk');

        if (isEmpty) {
            allValid = false;

            if (!hasAsterisk) {
                const asterisk = document.createElement('span');
                asterisk.textContent = '*';
                asterisk.className = 'required-asterisk';
                asterisk.style.color = 'red';
                asterisk.style.position = 'absolute';
                asterisk.style.top = '0';
                asterisk.style.right = '8px';
                asterisk.style.fontWeight = 'bold';
                asterisk.style.fontSize = '16px';
                parent.style.position = 'relative';
                parent.appendChild(asterisk);
            }
            if (inputToStyle && isBorder === true) {
                inputToStyle.style.setProperty('border', '1px solid red', 'important');
                inputToStyle.style.borderRadius = '4px';
            }


        } else {
            if (hasAsterisk) hasAsterisk.remove();
            if (inputToStyle) inputToStyle.style.border = '';
        }
    });

    return allValid;
}

function getExtentAsWKT(map) {
    // extent (3857)
    const extent3857 = map.getView().calculateExtent(map.getSize());
    // 4326 çevir
    const [minX, minY, maxX, maxY] = transformExtent(extent3857, 'EPSG:3857', 'EPSG:4326');

    // WKT POLYGON oluştur
    const wkt = `POLYGON((${minX} ${minY}, ${maxX} ${minY}, ${maxX} ${maxY}, ${minX} ${maxY}, ${minX} ${minY}))`;
    return wkt;
}



export const otherTool = {
    validateEmail,
    sleep,
    createAuthorizedWmsSource,
    toPascalCase,
    maxWindow,
    getCardColor,
    groupBy,
    copyGeometry,
    addContextMenu,
    removeContextMenuItem,
    defaultZoom,
    addPopup,
    markEmptyFieldsWithAsterisk,
    getExtentAsWKT,
}

export default otherTool;
